// extracted by mini-css-extract-plugin
export default {"FilterSelectionValue":"FilterSelectionValue-module-b6abfc9f5e56f99fa540"};